import React from "react";
import "./styles/global.css";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import { logger } from "./utils";
// Initialize performance monitoring early
import { performanceMonitor } from "./utils/performanceMonitor";

// Mark app start time for performance tracking
performanceMonitor.mark('app-start');

const container = document.getElementById("root") as HTMLElement;
// Enable concurrent features for better hydration performance
const root = createRoot(container, {
  // Enables React 18 concurrent rendering optimizations
  onRecoverableError: (error) => {
    logger.log(error);
  },
});

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
);

// Track render completion
performanceMonitor.mark('app-rendered');
performanceMonitor.measure('app-render-time', 'app-start', 'app-rendered');

// Initialize Sentry after React has rendered to avoid blocking initial load
// This improves Time to Interactive (TTI) and First Contentful Paint (FCP)
if (typeof window !== "undefined" && "requestIdleCallback" in window) {
  requestIdleCallback(
    () => {
      import("./sentry").then(({ initSentry }) => initSentry());
    },
    { timeout: 2000 } // Fallback timeout
  );
} else {
  // Fallback for browsers without requestIdleCallback
  setTimeout(() => {
    import("./sentry").then(({ initSentry }) => initSentry());
  }, 1000);
}
